Billy.User.reopen({
    defaultProfilePicUrl: function() {
        return this.get('profilePic48Url') || Billy.image('misc/default-user-profile-pic.png')
    }.property('profilePic48Url'),

    hasStaffPermissions: function() {
        return this.get('isStaff') || this.get('isAdmin')
    }.property('isStaff', 'isAdmin')
})
